<div
  class="card card-custom"
  [ngClass]="{
    'card-body-progress': viewLoading,
    'card-body-progress-overlay': loadingAfterSubmit
  }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
  <!--begin::Form-->
  <form class="form" [formGroup]="relationshipEditForm" autocomplete="off">
    <div class="card-body">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>

      <div class="form-section form-section-first row">
        <div class="col-lg-12 d-flex">
          <div class="flex-grow-1">
            <kt-general-autocomplete
              [label]="'Contact'"
              [loadItemsFunction]="contactAutocompleteCall"
              [optionSearchFields]="contactSearchFields"
              [optionHeader]="stringUtils.getEntityHeader('CONTACT')"
              [optionFormatter]="stringUtils.getEntityFormatter.bind(stringUtils, 'CONTACT')"
              [valueFormatter]="stringUtils.displayName"
              [required]="true"
              [readOnly]="false"
              [control]="relationshipEditForm.get('entityInput')"
              [change]="onContactChange.bind(this)"
              [dataPath]="'data'"
              [placeholder]="'Select Contact'"
              #contactAutocomplete
            ></kt-general-autocomplete>
          </div>
          <button
            matTooltip="Add New Contact"
            class="btn btn-icon btn-light ml-2"
            aria-label="AddContact"
            (click)="openContactDialog()"
          >
            <i class="flaticon2-add-1 icon-sm"></i>
          </button>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Relation Category</mat-label>
            <mat-select formControlName="relationCategory" required>
              <mat-option *ngFor="let category of relationCategoryList" [value]="category">
                {{ category.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="relationshipEditForm.get('relationCategory').hasError('required')">
              Required field
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Description</mat-label>
            <mat-select formControlName="relationCategoryDescription" required>
              <mat-option
                *ngFor="let description of relationCategoryDescriptionList"
                [value]="description"
              >
                {{ description.description_type }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="relationshipEditForm.get('relationCategoryDescription').hasError('required')"
            >
              Required field
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Title</mat-label>
            <input matInput formControlName="title" />
          </mat-form-field>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile mb-4">
          <div class="mat-form-field-fluid">
            <mat-label class="row ml-1">Primary</mat-label>
            <mat-slide-toggle class="mr-2" formControlName="isPrimary"></mat-slide-toggle>
            <mat-hint align="start">
              <strong>{{ getPrimaryString('isPrimary') }}</strong>
            </mat-hint>
          </div>
        </div>

        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <div class="mat-form-field-fluid mb-4">
            <mat-label class="row ml-1">Financial Responsible</mat-label>
            <mat-slide-toggle
              class="mr-2"
              formControlName="financialResponsible"
            ></mat-slide-toggle>
            <mat-hint align="start">
              <strong>{{ getPrimaryString('financialResponsible') }}</strong>
            </mat-hint>
          </div>

          <div class="mat-form-field-fluid mb-4">
            <mat-label class="row ml-1">Emergency Contact</mat-label>
            <mat-slide-toggle class="mr-2" formControlName="emergencyContact"></mat-slide-toggle>
            <mat-hint align="start">
              <strong>{{ getPrimaryString('emergencyContact') }}</strong>
            </mat-hint>
          </div>

          <div class="row">
            <div class="col-sm-3 mb-4">
              <mat-label class="row ml-1">PHI Authorized</mat-label>
              <mat-slide-toggle
                class="mr-2"
                formControlName="phiAuthorized"
                (change)="onPhiAuthorizedChange()"
              ></mat-slide-toggle>
              <mat-hint align="start">
                <strong>{{ getPrimaryString('phiAuthorized') }}</strong>
              </mat-hint>
            </div>
            <div class="col-sm">
              <mat-radio-group
                formControlName="validUntilRevoked"
                (change)="onValidUntilRevokedChange()"
              >
                <mat-radio-button [value]="true"> Valid until revoked</mat-radio-button>

                <mat-radio-button [value]="false">Authorized up to</mat-radio-button>

                <mat-form-field appearance="standard" style="width: auto !important">
                  <input
                    matInput
                    formControlName="authorizedDate"
                    [matDatepicker]="authorziedDatePicker"
                    placeholder="MM/DD/YYYY"
                    ktDateMask
                    maxlength="10"
                    [min]="minDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="authorziedDatePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #authorziedDatePicker></mat-datepicker>
                  <mat-error
                    *ngIf="
                      relationshipEditForm.get('authorizedDate').hasError('required') &&
                      (relationshipEditForm.get('authorizedDate').dirty ||
                        relationshipEditForm.get('authorizedDate').touched)
                    "
                  >
                    Please Choose a Date
                  </mat-error>
                </mat-form-field>
              </mat-radio-group>

              <mat-error
                *ngIf="
                  relationshipEditForm.get('validUntilRevoked').hasError('required') &&
                  (relationshipEditForm.get('validUntilRevoked').dirty ||
                    relationshipEditForm.get('validUntilRevoked').touched)
                "
              >
                Please Select an Option
              </mat-error>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            cdkFocusInitial
            (click)="onNoClick()"
            matTooltip="Cancel changes"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="submit"
            mat-raised-button
            color="primary"
            (click)="save()"
            [disabled]="viewLoading"
            matTooltip="Save changes"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
  <!--end::Form-->
</div>
